export const LEGAL_REQUEST_CURRENT = 1;
export const LEGAL_REQUEST_NEW = 2;

export const LEGAL_REQUEST_TYPES = [
    { id: LEGAL_REQUEST_CURRENT, name: 'current' },
    { id: LEGAL_REQUEST_NEW, name: 'new' },
];
